<template>
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<style>
:root {
  --lds-ellipsis: 13px;
  --lds-ellipsis-top: 32px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: calc(6 * var(--lds-ellipsis));
  height: calc(6 * var(--lds-ellipsis));
}

.lds-ellipsis div {
  position: absolute;
  top: var(--lds-ellipsis-top);
  width: var(--lds-ellipsis);
  height: var(--lds-ellipsis);
  border-radius: 50%;
  background: var(--text-color-primary);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: calc(0.615 * var(--lds-ellipsis));
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: calc(0.615 * var(--lds-ellipsis));
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: calc(2.5 * var(--lds-ellipsis));
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: calc(4.3 * var(--lds-ellipsis));
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(calc(1.85 * var(--lds-ellipsis)), 0);
  }
}
</style>
